import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgKvika = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 186,
	height: 216,
	viewBox: "0 0 186 216",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M123.173 215.553H153.966V163.204L123.173 143.189V215.553ZM61.5865 184.759H92.3797V122.788L61.5865 102.772V184.759ZM0 153.966H30.7932V81.987L0 61.5865V153.966ZM30.7932 30.7932V81.987L61.5865 102.772V30.7932H30.7932ZM154.351 31.948V164.359L185.144 185.144V31.948H154.351ZM92.3797 0V122.788L123.173 143.573V0H92.3797Z",
		fill: "currentColor"
	})
});
export default SvgKvika;
